export default __webpack_public_path__ + "static/media/Imperator-Bold.8f86c052.ttf";